import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import {
  getNsdcQuestionThunk,
  createNsdcQuestionThunk,
} from "./Manage_Nsdc_Thunk";

const Manage_Nsdc = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //To get Nsdc Questioons
  const response = useSelector(
    (state) => state.Manage_Nsdc_Slice.nsdc_questions
  );
  //console.log("response------>", response);
  // For State Declaration
  const [show, setShow] = useState(false);

  const [questionType, setQuestionType] = useState("subjective");
  // //console.log("questionType-->", questionType);

  const [textArea, setTextArea] = useState("");
  // //console.log("textArea-->", textArea);

  //On tabs set
  const [key, setKey] = useState("subjective");
  // //console.log("key-->", key);
  const navigate_to = () => {
    navigate("/nsdc");
  };
  const [showUpdate, setShowUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [updateData, setUpdateData] = useState({
    A: "",
    B: "",
    C: "",
    D: "",
    answer: "",
    qid: new Date().getTime(),
    question: "",
    questiontype: "",
    _id: "",
  });
  //console.log("updateData-->", updateData);

  // For TABS
  const [value, setValue] = React.useState("subjective");

  const handleChange = (event, newValue) => {
    // //console.log("check event--->",newValue)
    dispatch(getNsdcQuestionThunk(newValue));
    setValue(newValue);
  };

  const handleUpdateChanges = () => {
    api.put(`updatensdcquestion/${updateData._id}`, updateData).then(
      (response) => {
        //console.log("response-->", response.data);
        // setResult(response.data);
        if (response.data.status === "success") {
          dispatch(getNsdcQuestionThunk(value));
        }
      },
      (err) => {
        //console.log(err);
      }
    );

    setShowUpdate(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleShowUpdate = (x) => {
    //console.log("updatelog-->", x);
    setUpdateData({
      A: x.A,
      B: x.B,
      C: x.C,
      D: x.D,
      answer: x.answer,
      qid: new Date().getTime(),
      question: x.question,
      questiontype: x.questiontype,
      _id: x._id,
    });

    setShowUpdate(true);
  };

  // For Function

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [changeA, setChangeA] = useState("");
  const handleChangeA = (event) => {
    setChangeA(event.target.value);
  };
  const [changeB, setChangeB] = useState("");
  const handleChangeB = (event) => {
    setChangeB(event.target.value);
  };
  const [changeC, setChangeC] = useState("");
  const handleChangeC = (event) => {
    setChangeC(event.target.value);
  };
  const [changeD, setChangeD] = useState("");

  const handleChangeD = (event) => {
    setChangeD(event.target.value);
  };
  const [changeAns, setChangeAns] = useState("");

  const handleChangeAns = (event) => {
    setChangeAns(event.target.value);
  };

  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    setChangeQuestion(event.target.value);
  };

  const data = {
    A: changeA,
    B: changeB,
    C: changeC,
    D: changeD,
    answer: changeAns,
    qid: new Date().getTime(),
    question: changeQuestion,
    questiontype: questionType,
  };
  // //console.log("data-->", data);
  const handleSave = () => {
    setShow(false);
    setIsLoading(true);
    // dispatch(createNsdcQuestionThunk(data));
    createNsdcQuestionThunk(data).then((response) => {
      //console.log(response.data);
      if (response.data.status === "success") {
        dispatch(getNsdcQuestionThunk(data.questiontype));
      }
    });
    //  dispatch(getNsdcQuestionThunk(data.questiontype));
  };

  const handleTextArea = (event) => {
    setTextArea(event.target.value);
  };

  // On Type change
  const select_type_change = (event) => {
    // //console.log("changes", event.target);
    setQuestionType(event.target.value);
  };

  // //console.log("response-->", response);

  useEffect(() => {
    dispatch(getNsdcQuestionThunk(questionType));
  }, [dispatch]);

  const handleDelete = (x) => {
    // //console.log("delete-->", x);
    api.put(`deletensdcquestion/${x._id}`).then(
      (response) => {
        //console.log("response-->", response.data);
        // setResult(response.data);
        if (response.data.status === "success") {
          dispatch(getNsdcQuestionThunk(questionType));
        }
      },
      (err) => {
        //console.log(err);
      }
    );
  };

  return (
    <div>
      <h1>Nsdc Questions</h1>
      <Button
        onClick={navigate_to}
        variant="contained"
        sx={{ m: 1, minWidth: 120, marginTop: -6 }}
        size="small"
      >
        Back
      </Button>
      <div>
        {/* <h3>Add Quiz</h3>
        <div> </div> */}
        <div>
          <div>
            <Button
              style={{
                marginTop: 16,
                marginRight: "auto",
                marginLeft: "auto",
                display: "block",
              }}
              variant="contained"
              onClick={handleShow}
            >
              <AddIcon />
            </Button>
          </div>

          {/* For Add Quiz Modal */}
          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <InputLabel id="demo-select-small">Question Type</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={questionType}
                  label="Age"
                  onChange={select_type_change}
                >
                  <MenuItem value="">
                    <em>Select Question Type</em>
                  </MenuItem>

                  <MenuItem value="subjective">Subjective</MenuItem>
                  <MenuItem value="objective">Objective</MenuItem>
                </Select>
              </FormControl>
              {questionType === "subjective" ? (
                <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                  <TextField
                    id="filled-basic"
                    label="Subjective"
                    variant="filled"
                    onChange={handleChangeQuestion}
                  />
                </FormControl>
              ) : (
                <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                  <TextField
                    id="filled-basic"
                    label="Objective Question"
                    variant="filled"
                    onChange={handleChangeQuestion}
                  />

                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2} style={{ marginTop: 12 }}>
                      <Grid item xs={6} md={6}>
                        <TextField
                          id="outlined-basic"
                          label="Option A"
                          variant="outlined"
                          onChange={handleChangeA}
                        />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <TextField
                          id="outlined-basic"
                          label="Option B"
                          variant="outlined"
                          onChange={handleChangeB}
                        />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <TextField
                          id="outlined-basic"
                          label="Option C"
                          variant="outlined"
                          onChange={handleChangeC}
                        />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <TextField
                          id="outlined-basic"
                          label="Option D"
                          variant="outlined"
                          onChange={handleChangeD}
                        />
                      </Grid>
                    </Grid>

                    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                      <InputLabel id="demo-select-small">Ans:</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        label="Ans"
                        onChange={handleChangeAns}
                      >
                        <MenuItem value="">
                          <em>Select Answer</em>
                        </MenuItem>

                        <MenuItem value="A">A</MenuItem>
                        <MenuItem value="B">B</MenuItem>
                        <MenuItem value="C">C</MenuItem>
                        <MenuItem value="D">D</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </FormControl>
              )}
              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        {/* Nsdc Question Type Tabs */}
        <div style={{ border: "1px solid blue", width: "1100px" }}>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Subjective" value="subjective" />
                  <Tab label="Objective" value="objective" />
                </TabList>
              </Box>
              <TabPanel value="subjective">
                <table>
                  {response.map((x, i) => (
                    <tr>
                      <td style={{ width: "1000px" }}>
                        <b>
                          {i + 1}. {x.question}
                        </b>
                      </td>

                      <td>
                        <Button
                          variant="contained"
                          onClick={() => handleDelete(x)}
                        >
                          Delete
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="contained"
                          onClick={() => handleShowUpdate(x)}
                        >
                          Update
                        </Button>
                      </td>
                    </tr>
                  ))}
                </table>
              </TabPanel>
              <TabPanel value="objective">
                <table>
                  {response.map((x, i) => (
                    <thead>
                      <tr>
                        <th style={{ width: "1000px", textAlign: "left" }}>
                          {i + 1}.{x.question}
                        </th>
                        <th>
                          <Button
                            variant="contained"
                            onClick={() => handleDelete(x)}
                          >
                            Delete
                          </Button>
                        </th>
                        <th>
                          <Button
                            variant="contained"
                            onClick={() => handleShowUpdate(x)}
                          >
                            Update
                          </Button>
                        </th>
                      </tr>
                      <tbody>
                        <tr>
                          <td style={{ width: "400px" }}>A.{x.A}</td>
                          <td>B.{x.B}</td>
                        </tr>
                        <tr>
                          <td>C.{x.C}</td>
                          <td>D.{x.D}</td>
                        </tr>
                        <tr>
                          <td>Answer.{x.answer}</td>
                        </tr>
                      </tbody>
                    </thead>
                  ))}
                </table>
              </TabPanel>

              {value == "subjective" ? (
                <Modal
                  open={showUpdate}
                  onClose={handleCloseUpdate}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                      <TextField
                        id="filled-basic"
                        label="Subjective"
                        variant="filled"
                        value={updateData.question}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            question: e.target.value,
                          })
                        }
                      />
                    </FormControl>

                    <Button
                      variant="outlined"
                      style={{ marginLeft: 12 }}
                      onClick={handleCloseUpdate}
                    >
                      Close
                    </Button>
                    <Button variant="contained" onClick={handleUpdateChanges}>
                      Update
                    </Button>
                  </Box>
                </Modal>
              ) : (
                <Modal
                  open={showUpdate}
                  onClose={handleCloseUpdate}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                      <TextField
                        id="filled-basic"
                        label="Objective Question"
                        variant="filled"
                        value={updateData.question}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            question: e.target.value,
                          })
                        }
                      />

                      <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2} style={{ marginTop: 12 }}>
                          <Grid item xs={6} md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Option A"
                              variant="outlined"
                              value={updateData.A}
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  A: e.target.value,
                                })
                              }
                            />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Option B"
                              variant="outlined"
                              value={updateData.B}
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  B: e.target.value,
                                })
                              }
                            />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Option C"
                              variant="outlined"
                              value={updateData.C}
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  C: e.target.value,
                                })
                              }
                            />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Option D"
                              variant="outlined"
                              value={updateData.D}
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  D: e.target.value,
                                })
                              }
                            />
                          </Grid>
                        </Grid>

                        <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                          <InputLabel id="demo-select-small">Ans:</InputLabel>
                          <Select
                            labelId="demo-select-small"
                            id="demo-select-small"
                            label="Ans"
                            value={updateData.answer}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                answer: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="">
                              <em>Select Answer</em>
                            </MenuItem>

                            <MenuItem value="A">A</MenuItem>
                            <MenuItem value="B">B</MenuItem>
                            <MenuItem value="C">C</MenuItem>
                            <MenuItem value="D">D</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </FormControl>

                    <Button
                      variant="outlined"
                      style={{ marginLeft: 12 }}
                      onClick={handleCloseUpdate}
                    >
                      Close
                    </Button>
                    <Button variant="contained" onClick={handleUpdateChanges}>
                      Update
                    </Button>
                  </Box>
                </Modal>
              )}
            </TabContext>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Manage_Nsdc;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
